// extracted by mini-css-extract-plugin
export default {"main":"TitleRow-main_GpNmd","root":"TitleRow-root_EBlDR","icon":"TitleRow-icon_KhmOL"};